import React from 'react';

import nodeRiverBlack from '../assets/noderiver-black.svg';
import nodeRiverWhite from '../assets/noderiver-white.svg';

const VARIANT_TO_ASSET = {
  light: nodeRiverWhite,
  dark: nodeRiverBlack,
};

const NodeRiverSpinner = React.forwardRef(
  (
    {
      variant = 'dark',
      size = 96,
      label = 'Loading NodeRiver experience',
      className = '',
      style = {},
      logoSrc,
    },
    ref
  ) => {
    const fallbackAsset = VARIANT_TO_ASSET[variant] ?? VARIANT_TO_ASSET.dark;
    const asset = logoSrc ?? fallbackAsset;
    const mergedClassName = ['noderiver-spinner', className].filter(Boolean).join(' ');

    return (
      <div
        ref={ref}
        className={mergedClassName}
        style={{ width: size, height: size, ...style }}
        role="status"
        aria-live="polite"
        aria-label={label}
      >
        <img src={asset} alt="" draggable="false" />
        <span className="sr-only">{label}</span>
      </div>
    );
  }
);

NodeRiverSpinner.displayName = 'NodeRiverSpinner';

export default NodeRiverSpinner;
